"use strict"

function clearSessionIfNeeded() {
    for(const cookie of document.cookie.split(/\s*;\s*/)) {
        let md
        if(md = cookie.match(/^PHPSESSID=(.+)/)) {
            const value = decodeURIComponent(md[1])
            if(sessionStorage.uid != value.substring(value.length - 2)) {
                sessionStorage.clear()
                sessionStorage.uid = value.substring(value.length - 2)
            }
        }
    }
}
